<ng-content></ng-content>
<form *ngIf="scheduleForm" [formGroup]="scheduleForm" [class]="formClass">
    <div class="d-flex align-items-center justify-content-between">
        <!------- Date --------->
        <div class="col-6">
            <ng-container *ngIf="dateFormat == 'short'; else fulldateFieldTemp;">
                <mat-form-field appearance="outline" shortDateFormat>
                    <mat-label>Date*</mat-label>
                    <input
                        matInput
                        formControlName="date"
                        (click)="datepicker.open()"
                        (keydown)="restrictInput()"
                        (dateChange)="emitChanges()" 
                        [matDatepicker]="datepicker" 
                        [min]="minDate" 
                        readonly
                    />
                    <mat-datepicker-toggle matSuffix [for]="datepicker">
                    </mat-datepicker-toggle>
                    <mat-datepicker #datepicker></mat-datepicker>
                </mat-form-field>
            </ng-container>
            <ng-template #fulldateFieldTemp>
                <mat-form-field appearance="outline">
                    <mat-label>Date*</mat-label>
                    <input
                        matInput
                        formControlName="date"
                        (click)="datepicker.open()"
                        (keydown)="restrictInput()"
                        (dateChange)="emitChanges()" 
                        [matDatepicker]="datepicker" 
                        [min]="minDate" 
                        readonly
                    />
                    <mat-datepicker-toggle matSuffix [for]="datepicker">
                    </mat-datepicker-toggle>
                    <mat-datepicker #datepicker></mat-datepicker>
                </mat-form-field>
            </ng-template>
        </div>
        
        <!------- Time --------->
        <div class="col-6">
            <mat-form-field appearance="outline">
                <mat-label>Time*</mat-label>
                <mat-select formControlName="time" (selectionChange)="emitChanges()">
                    <ng-container *ngIf="timeData">
                        <mat-option *ngFor="let timeD of timeData" [value]="timeD">{{ timeD.label }}</mat-option>
                    </ng-container>
                </mat-select>
                <mat-error *ngIf="scheduleForm.controls['time']?.hasError('pattern')">Enter a Valid time</mat-error>
            </mat-form-field>
        </div>
    </div>
</form>